import { getHotelTypes, getHotelAmenities, getHotelThemes, getRoomAmenities } from 'b2b-common/services/api/hotel'
import { getSearchParams, getSearchResults, search } from 'b2b-common/services/api/package'
// import { sortByHotDeal } from 'b2b-common/utils/hotel/sorting'
import { sortByPrice } from 'b2b-common/utils/hotel/sorting'

export default {
  initDataLoaded: false,

  sortMethod: sortByPrice,

  hotelTypes: [],
  hotelAmenities: [],
  hotelThemes: [],
  roomAmenities: [],

  distribution: null,

  params: {
    packageType: 'package',
    rooms: [{ adults: 2, childAges: [] }],
    countryName: '',
    resortName: ''
  },
  results: [],
  hasTransport: true,
  minPrice: 0,
  maxPrice: 0,

  getDuration () {
    return this.params.duration
  },

  getNoRooms () {
    return this.params.rooms.length
  },

  getNoAdults () {
    return this.params.rooms.reduce((acc, room) => acc + room.adults, 0)
  },

  getNoChildren () {
    return this.params.rooms.reduce((acc, room) => acc + room.ages.length, 0)
  },

  getNoPax () {
    return this.getNoAdults() + this.getNoChildren()
  },

  async init () {
    if (this.initDataLoaded) return Promise.resolve(true)
    const initialRequests = {
      params: getSearchParams({ packageType: this.params.packageType, dc: this.distribution }),
      results: getSearchResults({ packageType: this.params.packageType, dc: this.distribution }),
      hotelAmenities: getHotelAmenities(),
      roomAmenities: getRoomAmenities(),
      hotelThemes: getHotelThemes(),
      hotelTypes: getHotelTypes()
    }
    const res = await Promise.all(Object.values(initialRequests))
    const data = {}
    for (let i = 0; i < Object.keys(initialRequests).length; i++) {
      data[Object.keys(initialRequests)[i]] = res[i]
    }
    this.params = data.params
    this.results = data.results.results
    this.hotelAmenities = data.hotelAmenities
    this.roomAmenities = data.roomAmenities
    this.hotelThemes = data.hotelThemes
    this.hotelTypes = data.hotelTypes
    this.initDataLoaded = true
    return true
  },

  sort ({ sortMethod = sortByPrice }) {
    this.sortMethod = sortMethod
    this.results = this.results.sort(this.sortMethod)
  },

  async search (params) {
    const res = await search({ ...params })
    const newParams = await getSearchParams({ packageType: this.params.packageType, dc: this.distribution })
    this.params = newParams
    this.results = res.results
    this.hasTransport = res.has_transport
    this.sort({ sortMethod: this.sortMethod })
    return this.results
  }

}
